// Status / priority pills. Colored by a normalized class so the seeded codes
// (open/pending/solved/closed, low/normal/high/urgent) get distinct treatments.

function norm(code: string | null | undefined): string {
  return (code ?? "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "-");
}

/** Display text for a raw code: drop _/- separators so the seeded codes read as
 *  words ("in_progress" → "in progress"); .badge's text-transform:capitalize
 *  then renders "In Progress". The raw code still drives the color class. */
function label(code: string | null | undefined): string {
  return code ? code.replace(/[_-]+/g, " ") : "—";
}

export function StatusBadge({ code }: { code: string | null | undefined }) {
  const c = norm(code);
  return <span className={`badge st-${c}`} title="Status">{label(code)}</span>;
}

export function PriorityBadge({ code, color }: { code: string | null | undefined; color?: string | null }) {
  const c = norm(code);
  // A configured hex color (task/ticket priority `color`) tints the pill; without
  // one we fall back to the built-in per-code class color.
  if (color) {
    return (
      <span
        className="badge"
        title="Priority"
        style={{
          color,
          background: `color-mix(in srgb, ${color} 12%, transparent)`,
          borderColor: `color-mix(in srgb, ${color} 36%, transparent)`,
        }}
      >
        {label(code)}
      </span>
    );
  }
  return <span className={`badge pr-${c}`} title="Priority">{label(code)}</span>;
}
